import { useCallback, useMemo, useState } from 'react';
import { SUB_CATEGORY_LIST_FILTER_OPTION_MODEL, SUB_CATEGORY_LIST_SORT_OPTION_MODEL } from './constants';
import { getListWithFilterOption, getListWithSortOption } from './utils';

/**
 * 서브 카테고리 정렬 및 검색 기능을 관리하는 hook
 * @param initialSubCategoryList - state 로 관리되고 있지 않은 서버에서 가져온 서브 카테고리 리스트
 * @returns {{sortOption: [], resetFilter: resetFilter, filterOption: {name: null, isExhibit: null, id: null, status: null}, subCategoryListWithFilter: *, dispatchFilter: dispatchFilter}}
 */
const useSubCategoryFilter = (initialSubCategoryList) => {
  const [filterOption, setFilterOption] = useState(SUB_CATEGORY_LIST_FILTER_OPTION_MODEL);
  const [sortOption, setSortOption] = useState(SUB_CATEGORY_LIST_SORT_OPTION_MODEL);

  // 검색 및 정렬이 적용된 서브 카테고리 리스트
  const subCategoryListWithFilter = useMemo(() => {
    return getListWithSortOption(getListWithFilterOption(initialSubCategoryList, filterOption), sortOption);
  }, [initialSubCategoryList, filterOption, sortOption]);

  const dispatchFilter = useCallback(({ filterOption, sortOption }) => {
    if (filterOption) {
      setFilterOption(filterOption);
    }
    if (sortOption) {
      setSortOption(sortOption);
    }
  }, []);

  const resetFilter = useCallback(() => {
    setFilterOption(SUB_CATEGORY_LIST_FILTER_OPTION_MODEL);
    setSortOption(SUB_CATEGORY_LIST_SORT_OPTION_MODEL);
  }, []);

  return {
    filterOption,
    sortOption,
    subCategoryListWithFilter,
    dispatchFilter,
    resetFilter,
  };
};

export default useSubCategoryFilter;
